<template>
  <div class="wscn-http404-container pt-5 bg-white" style="min-height: calc(100vh - 300px);">
    <div class="wscn-http404">
      <div class="pic-404 m-auto text-center max-w-xl">
        <img class="pic-404__parent m-auto" src="@/assets/default_main/404.png" alt="404">
      </div>
      <div class="bullshit text-center">
        <!-- <div class="bullshit__oops">Đường dẫn không đúng.</div>
        <div class="bullshit__info">Bản quyền thuộc công ty CPĐT Vega Fintech
          <a style="color:#20a0ff" href="https://vclick.vn" target="_blank">Vclick.vn</a>
        </div> -->
        <div class="bullshit__headline text-2xl font-bold mt-5">{{ message }}</div>
        <div class="bullshit__info text-lg">Vui lòng kiểm tra xem URL bạn đã nhập, hoặc nhấp vào nút bên dưới để quay lại trang chủ.</div>
        <div class="border-gray-200 border-2 p-2 rounded-lg mt-3 w-48 m-auto">
            <router-link to="/" class="font-bold"> Về trang chủ </router-link>
           
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Page404',
  computed: {
    message() {
      return 'Không tìm thấy trang'
    }
  },
  head: {
        title: {
            inner: 'Vclick | Duyệt vay lên đến 80 triệu, lãi suất hấp dẫn chỉ từ 1.66%'
        },
        meta: [
          
            { name: 'description', content: 'Duyệt vay dễ dàng, tỉ lệ giải ngân cao' },
        ],
        link: [
            {
                rel: 'canonical', href: 'https://vclick.vn/'
            },
            {
                rel: 'alternate', href: 'https://vclick.vn/'
            }
        ]
    }
}
</script>

